import * as Sentry from '@sentry/browser';

export default function writeSentry(error, url = '', res, options = {}) {
  try {
    Sentry.withScope(scope => {
      scope.setExtras({
        url,
        options,
        responseBody: JSON.stringify(res),
      })
      Sentry.captureException(error)
    })
  } catch (e) {
    console.log(e)
  }
}
